import { QueryFunctionContext } from 'react-query';
import { baseQuery } from '../baseQuery';
import { EmailTemplate } from 'types';

type QueryKey = ['email-templates', 'task', { taskId?: number }];

export const getEmailTemplates = async ({ queryKey }: QueryFunctionContext<QueryKey>) => {
  const taskId = queryKey[2].taskId;
  const params = new URLSearchParams({ per_page: '100' });

  if (taskId !== undefined) {
    params.append('filter[forTask]', String(taskId));
  }

  const { data } = await baseQuery(`email-templates?${params.toString()}`);

  return (data ?? []) as EmailTemplate[];
};
